// import React, {
//   useMemo,
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
// } from "react";
// import "./ordersList.css";
// import {
//   FiPlus,
//   FiChevronRight,
//   FiEye,
//   FiEdit2,
//   FiTrash2,
//   FiRefreshCw,
//   FiPackage,
//   FiCheck,
//   FiX,
//   FiCalendar,
//   FiFilter,
//   FiChevronDown,
// } from "react-icons/fi";
// import { BiExport } from "react-icons/bi";
// import OrderForm from "./orderForm";
// import OrderDetails from "./orderDetails";

// const API_BASE = process.env.REACT_APP_EP || "http://localhost:5000";

// const RANGE_TABS = [
//   { key: "all", label: "All Time" },
//   { key: "12m", label: "12 Months" },
//   { key: "30d", label: "30 Days" },
//   { key: "7d", label: "7 Days" },
//   { key: "24h", label: "24 Hour" },
// ];

// const PAGE_SIZE = 10;

// const inrFormatter = new Intl.NumberFormat("en-IN", {
//   style: "currency",
//   currency: "INR",
//   maximumFractionDigits: 2,
// });
// const formatINR = (value) => inrFormatter.format(value ?? 0);

// const formatDateLabel = (dateString) => {
//   if (!dateString) return "-";
//   try {
//     return new Date(dateString).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   } catch {
//     return "-";
//   }
// };

// const getDateRangeParams = (rangeKey) => {
//   const now = new Date();
//   let startDate = null;

//   switch (rangeKey) {
//     case "24h":
//       startDate = new Date(now.getTime() - 24 * 60 * 60 * 1000);
//       break;
//     case "7d":
//       startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
//       break;
//     case "30d":
//       startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
//       break;
//     case "12m":
//       startDate = new Date(
//         now.getFullYear() - 1,
//         now.getMonth(),
//         now.getDate()
//       );
//       break;
//     default:
//       return {};
//   }

//   return {
//     start_date: startDate?.toISOString(),
//     end_date: now.toISOString(),
//   };
// };

// const getStatusClass = (status) => {
//   const s = (status || "").toLowerCase();
//   if (s === "processing") return "status-processing";
//   if (s === "shipped" || s === "shipping") return "status-shipped";
//   if (s === "delivered") return "status-delivered";
//   if (s === "packed") return "status-packed";
//   if (s === "cancelled" || s === "canceled") return "status-cancelled";
//   return "status-pending";
// };

// const truncateEmail = (email, maxLength = 10) => {
//   if (!email) return "";
//   return email.length > maxLength ? email.slice(0, maxLength) + "..." : email;
// };

// const parseMaybeJson = (value) => {
//   if (!value) return null;
//   if (typeof value === "object") return value;
//   if (typeof value !== "string") return null;
//   try {
//     return JSON.parse(value);
//   } catch {
//     return null;
//   }
// };

// const normalizeLocationFromOrder = (order) => {
//   const addr =
//     parseMaybeJson(order.shippingAddress) ||
//     parseMaybeJson(order.shipping_address) ||
//     order.shippingAddress ||
//     order.shipping_address ||
//     null;

//   const district =
//     order?.panchayat_district ||
//     order?.panchayatDistrict ||
//     addr?.district ||
//     "";

//   const taluk =
//     order?.panchayat_taluk ||
//     order?.panchayatTaluk ||
//     addr?.taluk ||
//     "";

//   const panchayat =
//     order?.panchayat_name ||
//     order?.panchayatName ||
//     addr?.panchayat ||
//     order?.customerName ||
//     "";

//   return { district, taluk, panchayat };
// };

// // Toast Notification Component
// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const timer = setTimeout(onClose, 4000);
//     return () => clearTimeout(timer);
//   }, [onClose]);

//   return (
//     <div className={`toast toast-${type}`}>
//       <div className="toast-icon">
//         {type === "success" ? <FiCheck /> : <FiX />}
//       </div>
//       <span className="toast-message">{message}</span>
//       <button className="toast-close" onClick={onClose}>
//         ×
//       </button>
//     </div>
//   );
// };

// // Multi-Select Dropdown Component with Checklist
// const MultiSelectDropdown = ({
//   label,
//   options,
//   selectedValues,
//   onChange,
//   disabled,
//   placeholder = "Select...",
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleToggle = (value) => {
//     if (selectedValues.includes(value)) {
//       onChange(selectedValues.filter((v) => v !== value));
//     } else {
//       onChange([...selectedValues, value]);
//     }
//   };

//   const handleSelectAll = () => {
//     if (selectedValues.length === options.length) {
//       onChange([]);
//     } else {
//       onChange(options.map((opt) => opt.value || opt));
//     }
//   };

//   const getDisplayText = () => {
//     if (selectedValues.length === 0) return placeholder;
//     if (selectedValues.length === 1) {
//       const opt = options.find((o) => (o.value || o) === selectedValues[0]);
//       return opt?.label || opt?.name || selectedValues[0];
//     }
//     return `${selectedValues.length} selected`;
//   };

//   return (
//     <div
//       className={`multi-select-dropdown ${disabled ? "disabled" : ""}`}
//       ref={dropdownRef}
//     >
//       <button
//         type="button"
//         className={`multi-select-trigger ${isOpen ? "open" : ""}`}
//         onClick={() => !disabled && setIsOpen(!isOpen)}
//         disabled={disabled}
//       >
//         <span className="multi-select-text">{getDisplayText()}</span>
//         <FiChevronDown className={`multi-select-arrow ${isOpen ? "rotated" : ""}`} />
//       </button>

//       {isOpen && !disabled && (
//         <div className="multi-select-menu">
//           {options.length > 0 && (
//             <div className="multi-select-item select-all" onClick={handleSelectAll}>
//               <div className={`custom-checkbox ${selectedValues.length === options.length ? "checked" : ""}`}>
//                 {selectedValues.length === options.length && <FiCheck />}
//               </div>
//               <span>Select All</span>
//             </div>
//           )}
          
//           <div className="multi-select-options">
//             {options.length === 0 ? (
//               <div className="multi-select-empty">No options available</div>
//             ) : (
//               options.map((option) => {
//                 const value = option.value || option.name || option;
//                 const labelText = option.label || option.name || option;
//                 const isSelected = selectedValues.includes(value);

//                 return (
//                   <div
//                     key={value}
//                     className={`multi-select-item ${isSelected ? "selected" : ""}`}
//                     onClick={() => handleToggle(value)}
//                   >
//                     <div className={`custom-checkbox ${isSelected ? "checked" : ""}`}>
//                       {isSelected && <FiCheck />}
//                     </div>
//                     <span>{labelText}</span>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const ORDER_STATUS_OPTIONS = [
//   "all",
//   "PLACED",
//   "PROCESSING",
//   "PACKED",
//   "SHIPPED",
//   "DELIVERED",
//   "CANCELLED",
// ];

// const PAYMENT_STATUS_OPTIONS = [
//   "all",
//   "PAID",
//   "UNPAID",
//   "PARTIAL PAID",
// ];

// // Updated default filters - arrays for multi-select
// const defaultLocationFilters = {
//   districts: [],      // Changed to array
//   taluks: [],         // Changed to array
//   panchayats: [],     // Changed to array
//   orderStatus: "all", // Renamed from status
//   paymentStatus: "all", // New filter
// };

// const normalizeText = (v) => (v || "").toString().trim().toLowerCase();

// const OrdersList = () => {
//   const [mode, setMode] = useState("table");
//   const [orders, setOrders] = useState([]);
//   const [editingOrder, setEditingOrder] = useState(null);
//   const [viewingOrder, setViewingOrder] = useState(null);
//   const [preSelectedPanchayat, setPreSelectedPanchayat] = useState(null);

//   const [activeRange, setActiveRange] = useState("all");
//   const [currentPage, setCurrentPage] = useState(1);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [toasts, setToasts] = useState([]);

//   // Date filter
//   const [showDatePopover, setShowDatePopover] = useState(false);
//   const [dateDraft, setDateDraft] = useState({ start: "", end: "" });
//   const [dateFilter, setDateFilter] = useState({ start: "", end: "" });

//   // Filters panel (district/taluk/panchayat/status)
//   const [showFilters, setShowFilters] = useState(false);
//   const [filters, setFilters] = useState(defaultLocationFilters);

//   // Dropdown options from API
//   const [districts, setDistricts] = useState([]);
//   const [taluks, setTaluks] = useState([]);
//   const [panchayats, setPanchayats] = useState([]);

//   const filterAreaRef = useRef(null);

//   const isDateFilterActive = Boolean(dateFilter.start || dateFilter.end);

//   // Updated active filter check for arrays
//   const hasActiveFilters =
//     filters.districts.length > 0 ||
//     filters.taluks.length > 0 ||
//     filters.panchayats.length > 0 ||
//     filters.orderStatus !== "all" ||
//     filters.paymentStatus !== "all";

//   const activeFilterCount = [
//     filters.districts.length > 0,
//     filters.taluks.length > 0,
//     filters.panchayats.length > 0,
//     filters.orderStatus !== "all",
//     filters.paymentStatus !== "all",
//   ].filter(Boolean).length;

//   // ---------- Toast helpers ----------
//   const addToast = useCallback((message, type = "success") => {
//     const id = Date.now();
//     setToasts((prev) => [...prev, { id, message, type }]);
//   }, []);

//   const removeToast = useCallback((id) => {
//     setToasts((prev) => prev.filter((t) => t.id !== id));
//   }, []);

//   // ---------- Date filter handlers ----------
//   const applyDateFilter = () => {
//     setDateFilter(dateDraft);
//     setCurrentPage(1);
//     setShowDatePopover(false);
//   };

//   const clearDateFilter = () => {
//     setDateDraft({ start: "", end: "" });
//     setDateFilter({ start: "", end: "" });
//     setCurrentPage(1);
//   };

//   // ---------- Close date popover when clicking outside ----------
//   useEffect(() => {
//     const handleOutsideClick = (e) => {
//       if (!filterAreaRef.current) return;
//       if (!filterAreaRef.current.contains(e.target)) {
//         setShowDatePopover(false);
//       }
//     };

//     document.addEventListener("mousedown", handleOutsideClick);
//     document.addEventListener("touchstart", handleOutsideClick);
//     return () => {
//       document.removeEventListener("mousedown", handleOutsideClick);
//       document.removeEventListener("touchstart", handleOutsideClick);
//     };
//   }, []);

//   // ---------- Pre-selected panchayat (from CustomersList) ----------
//   useEffect(() => {
//     const storedPanchayat = sessionStorage.getItem("selectedPanchayat");
//     const orderAction = sessionStorage.getItem("orderAction");

//     if (storedPanchayat && orderAction === "salesOrder") {
//       try {
//         const panchayat = JSON.parse(storedPanchayat);
//         setPreSelectedPanchayat(panchayat);
//         setEditingOrder(null);
//         setMode("form");

//         sessionStorage.removeItem("selectedPanchayat");
//         sessionStorage.removeItem("orderAction");
//       } catch (e) {
//         console.error("Error parsing stored panchayat:", e);
//       }
//     }
//   }, []);

//   // ---------- Fetch districts ----------
//   useEffect(() => {
//     const fetchDistricts = async () => {
//       try {
//         const res = await fetch(`${API_BASE}/api/locations/districts`);
//         const data = await res.json();
//         if (data?.success) setDistricts(data.data || []);
//       } catch (err) {
//         console.error("Error fetching districts:", err);
//       }
//     };
//     fetchDistricts();
//   }, []);

//   // ---------- Fetch panchayaths list ----------
//   const fetchPanchayathsList = useCallback(
//     async (districtNames, talukNames) => {
//       if (!districtNames || districtNames.length === 0) {
//         setPanchayats([]);
//         return;
//       }
//       try {
//         // Fetch for all selected districts
//         const allPanchayats = [];
        
//         for (const districtName of districtNames) {
//           const params = new URLSearchParams({
//             page: "1",
//             limit: "1000",
//             district: districtName,
//           });
          
//           // If taluks are selected, filter by them
//           if (talukNames && talukNames.length > 0) {
//             // We need to fetch for each taluk or handle on client side
//             for (const talukName of talukNames) {
//               params.set("taluk", talukName);
              
//               const token = sessionStorage.getItem("authToken");
//               const headers = {};
//               if (token) headers["Authorization"] = `Bearer ${token}`;

//               const res = await fetch(
//                 `${API_BASE}/api/panchayaths/fetch?${params.toString()}`,
//                 { headers }
//               );
//               const data = await res.json();

//               if (res.ok && data && data.success !== false) {
//                 const list = Array.isArray(data.data?.panchayaths)
//                   ? data.data.panchayaths
//                   : [];
//                 allPanchayats.push(...list);
//               }
//             }
//           } else {
//             const token = sessionStorage.getItem("authToken");
//             const headers = {};
//             if (token) headers["Authorization"] = `Bearer ${token}`;

//             const res = await fetch(
//               `${API_BASE}/api/panchayaths/fetch?${params.toString()}`,
//               { headers }
//             );
//             const data = await res.json();

//             if (res.ok && data && data.success !== false) {
//               const list = Array.isArray(data.data?.panchayaths)
//                 ? data.data.panchayaths
//                 : [];
//               allPanchayats.push(...list);
//             }
//           }
//         }

//         // Remove duplicates and map
//         const uniquePanchayats = Array.from(
//           new Map(allPanchayats.map((p) => [p.name || p.panchayat, p])).values()
//         );

//         const mapped = uniquePanchayats
//           .map((p) => ({
//             name: p.name || p.panchayat || "",
//             taluk: p.taluk || "",
//             district: p.district || "",
//           }))
//           .filter((p) => p.name);

//         setPanchayats(mapped);
//       } catch (err) {
//         console.error("Error fetching panchayaths:", err);
//         setPanchayats([]);
//       }
//     },
//     []
//   );

//   // ---------- Fetch taluks when districts change ----------
//   useEffect(() => {
//     const selectedDistricts = filters.districts;

//     const fetchTaluks = async (districtNames) => {
//       if (!districtNames || districtNames.length === 0) {
//         setTaluks([]);
//         return;
//       }
//       try {
//         const allTaluks = [];
//         for (const district of districtNames) {
//           const res = await fetch(
//             `${API_BASE}/api/locations/taluks?district=${encodeURIComponent(district)}`
//           );
//           const data = await res.json();
//           if (data?.success) {
//             allTaluks.push(...(data.data || []));
//           }
//         }
//         // Remove duplicates
//         const uniqueTaluks = Array.from(
//           new Map(allTaluks.map((t) => [t.name, t])).values()
//         );
//         setTaluks(uniqueTaluks);
//       } catch (err) {
//         console.error("Error fetching taluks:", err);
//         setTaluks([]);
//       }
//     };

//     // Reset dependent filters and lists
//     setTaluks([]);
//     setPanchayats([]);
//     setFilters((prev) => ({
//       ...prev,
//       taluks: [],
//       panchayats: [],
//     }));

//     if (selectedDistricts.length === 0) return;

//     fetchTaluks(selectedDistricts);
//     fetchPanchayathsList(selectedDistricts, []);
//   }, [filters.districts, fetchPanchayathsList]);

//   // ---------- Fetch panchayats when taluks change ----------
//   useEffect(() => {
//     const selectedDistricts = filters.districts;
//     const selectedTaluks = filters.taluks;

//     // Reset panchayat selection
//     setFilters((prev) => ({
//       ...prev,
//       panchayats: [],
//     }));

//     if (selectedDistricts.length === 0) {
//       setPanchayats([]);
//       return;
//     }

//     fetchPanchayathsList(selectedDistricts, selectedTaluks);
//   }, [filters.taluks, filters.districts, fetchPanchayathsList]);

//   // ---------- Reset page when filters/date change ----------
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filters, dateFilter]);

//   // ---------- Fetch orders ----------
//   const fetchOrders = useCallback(async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       const params = getDateRangeParams(activeRange);
//       const queryString = new URLSearchParams(params).toString();
//       const url = `${API_BASE}/api/orders${queryString ? `?${queryString}` : ""}`;

//       const response = await fetch(url, {
//         method: "GET",
//         headers: { "Content-Type": "application/json" },
//       });

//       if (!response.ok) throw new Error("Failed to fetch orders");

//       const data = await response.json();
//       const ordersList = data.data || data.orders || [];

//       const transformed = ordersList.map((order) => {
//         const { district, taluk, panchayat } = normalizeLocationFromOrder(order);

//         return {
//           id: order.orderId,
//           orderNumber: `ORD-${(order.orderId || "")
//             .toString()
//             .substring(0, 8)
//             .toUpperCase()}`,
//           total: Number(order.totalAmount || 0),
//           status: order.orderStatus || "PENDING",
//           paymentStatus: order.paymentStatus || "UNPAID",
//           date: order.createdAt,
//           dateLabel: formatDateLabel(order.createdAt),
//           customer: {
//             name: order.customerName || "Unknown",
//             email: order.customerEmail || "",
//             phone: order.customerPhone || "",
//           },
//           itemsCount: order.itemsCount || 0,
//           totalItemsQuantity: order.totalItems || 0,
//           firstItemName: order.firstItemName || null,
//           firstItemImage: order.firstItemImage || null,
//           firstItemSku: order.firstItemSku || null,
//           items: [],
//           district,
//           taluk,
//           panchayat,
//         };
//       });

//       setOrders(transformed);
//     } catch (err) {
//       setError(err.message);
//       console.error("Error fetching orders:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeRange]);

//   useEffect(() => {
//     fetchOrders();
//   }, [fetchOrders]);

//   // ---------- Panchayat dropdown options ----------
//   const panchayatOptions = useMemo(() => {
//     if (filters.districts.length === 0) return [];
//     const names = panchayats.map((p) => p.name).filter(Boolean);
//     return Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
//   }, [panchayats, filters.districts]);

//   // ---------- Filtered orders ----------
//   const filteredOrders = useMemo(() => {
//     let list = [...orders];

//     // Date filter
//     if (dateFilter.start || dateFilter.end) {
//       const start = dateFilter.start
//         ? new Date(`${dateFilter.start}T00:00:00`)
//         : null;
//       const end = dateFilter.end
//         ? new Date(`${dateFilter.end}T23:59:59.999`)
//         : null;

//       list = list.filter((o) => {
//         const d = o?.date ? new Date(o.date) : null;
//         if (!d || isNaN(d.getTime())) return false;
//         if (start && d < start) return false;
//         if (end && d > end) return false;
//         return true;
//       });
//     }

//     const getOrderPanchayatName = (o) => normalizeText(o?.customer?.name);

//     // Panchayat filter (multi-select)
//     if (filters.panchayats.length > 0) {
//       const targetPanchayats = filters.panchayats.map((p) => normalizeText(p));
//       list = list.filter((o) => targetPanchayats.includes(getOrderPanchayatName(o)));
//     } 
//     // Taluk filter (if panchayats not selected but taluks are)
//     else if (filters.taluks.length > 0) {
//       const allowedPanchayats = panchayats
//         .filter((p) => filters.taluks.includes(p.taluk))
//         .map((p) => normalizeText(p.name));
      
//       if (allowedPanchayats.length > 0) {
//         list = list.filter((o) => allowedPanchayats.includes(getOrderPanchayatName(o)));
//       }
//     }
//     // District filter (if neither panchayats nor taluks are selected)
//     else if (filters.districts.length > 0) {
//       const allowedNames = new Set(
//         panchayats.map((p) => normalizeText(p.name))
//       );
//       if (allowedNames.size > 0) {
//         list = list.filter((o) => allowedNames.has(getOrderPanchayatName(o)));
//       } else {
//         list = [];
//       }
//     }

//     // Order Status filter
//     if (filters.orderStatus && filters.orderStatus !== "all") {
//       const sv = normalizeText(filters.orderStatus);
//       list = list.filter((o) => normalizeText(o?.status) === sv);
//     }

//     // Payment Status filter
//     if (filters.paymentStatus && filters.paymentStatus !== "all") {
//       const pv = normalizeText(filters.paymentStatus);
//       list = list.filter((o) => normalizeText(o?.paymentStatus) === pv);
//     }

//     return list;
//   }, [orders, dateFilter, filters, panchayats]);

//   // ---------- Pagination ----------
//   const { currentItems, totalItems, totalPages, safePage, startIndex } =
//     useMemo(() => {
//       const total = filteredOrders.length;
//       const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
//       const safe = Math.min(currentPage, pages);
//       const start = (safe - 1) * PAGE_SIZE;
//       const slice = filteredOrders.slice(start, start + PAGE_SIZE);
//       return {
//         currentItems: slice,
//         totalItems: total,
//         totalPages: pages,
//         safePage: safe,
//         startIndex: start,
//       };
//     }, [filteredOrders, currentPage]);

//   const changePage = (page) => {
//     if (page >= 1 && page <= totalPages) setCurrentPage(page);
//   };

//   // ---------- Fetch single order details ----------
//   const fetchOrderDetails = async (orderId) => {
//     try {
//       const response = await fetch(`${API_BASE}/api/orders/${orderId}`);
//       if (response.ok) {
//         const data = await response.json();
//         return data.data || data;
//       }
//     } catch (e) {
//       console.error(e);
//     }
//     return null;
//   };

//   // ---------- Update order status ----------
//   const updateOrderStatus = useCallback(
//     async (orderId, newStatus, updatedBy) => {
//       try {
//         const response = await fetch(
//           `${API_BASE}/api/orders/${orderId}/status`,
//           {
//             method: "PATCH",
//             headers: { "Content-Type": "application/json" },
//             credentials: "include",
//             body: JSON.stringify({
//               order_status: newStatus,
//               updatedBy,
//             }),
//           }
//         );

//         const data = await response.json();

//         if (!response.ok || data.success === false) {
//           throw new Error(data.message || "Failed to update order status");
//         }

//         const updatedOrder = data.data;

//         setOrders((prev) =>
//           prev.map((o) =>
//             o.id === updatedOrder.orderId
//               ? { ...o, status: updatedOrder.orderStatus || newStatus }
//               : o
//           )
//         );

//         setViewingOrder((prev) => {
//           if (!prev || prev.id !== updatedOrder.orderId) return prev;
//           return {
//             ...prev,
//             status: updatedOrder.orderStatus || newStatus,
//             statusHistory:
//               updatedOrder.statusHistory || updatedOrder.status_history || {},
//           };
//         });

//         return updatedOrder;
//       } catch (err) {
//         console.error("Status update error:", err);
//         addToast(err.message || "Failed to update status", "error");
//         throw err;
//       }
//     },
//     [addToast]
//   );

//   // ---------- Update payment status ----------
//   const updatePaymentStatus = useCallback(
//     async (orderId, newStatus, updatedBy) => {
//       try {
//         const response = await fetch(
//           `${API_BASE}/api/orders/${orderId}/payment`,
//           {
//             method: "PATCH",
//             headers: { "Content-Type": "application/json" },
//             credentials: "include",
//             body: JSON.stringify({
//               payment_status: newStatus,
//               updatedBy,
//             }),
//           }
//         );

//         const data = await response.json();

//         if (!response.ok || data.success === false) {
//           throw new Error(data.message || "Failed to update payment status");
//         }

//         const updatedOrder = data.data;

//         setOrders((prev) =>
//           prev.map((o) =>
//             o.id === updatedOrder.orderId
//               ? {
//                   ...o,
//                   paymentStatus:
//                     updatedOrder.paymentStatus || updatedOrder.payment_status || newStatus,
//                 }
//               : o
//           )
//         );

//         setViewingOrder((prev) => {
//           if (!prev || prev.id !== updatedOrder.orderId) return prev;
//           return {
//             ...prev,
//             paymentStatus:
//               updatedOrder.paymentStatus || updatedOrder.payment_status || newStatus,
//             payment_status:
//               updatedOrder.payment_status || updatedOrder.paymentStatus || newStatus,
//           };
//         });

//         return updatedOrder;
//       } catch (err) {
//         console.error("Payment status update error:", err);
//         addToast(err.message || "Failed to update payment status", "error");
//         throw err;
//       }
//     },
//     [addToast]
//   );

//   // ---------- Create order ----------
//   const createOrder = async (orderData) => {
//     setLoading(true);
//     try {
//       const payload = {
//         panchayat_name: orderData.panchayat_name || orderData.customer_name,
//         panchayat_taluk: orderData.panchayat_taluk || orderData.customer_taluk,
//         panchayat_district:
//           orderData.panchayat_district || orderData.customer_district,
//         panchayat_state: orderData.panchayat_state || "Karnataka",

//         items: orderData.items.map((item) => ({
//           sku: item.sku,
//           quantity: Number(item.quantity || item.qty),
//           unit_price: Number(item.unit_price || item.price),
//         })),

//         total_amount: orderData.total_amount,
//         tax_amount: orderData.tax_amount || 0,

//         shipping_address: orderData.shipping_address || {
//           panchayat: orderData.panchayat_name || orderData.customer_name,
//           taluk: orderData.panchayat_taluk || orderData.customer_taluk,
//           district: orderData.panchayat_district || orderData.customer_district,
//           state: "Karnataka",
//         },
//       };

//       const response = await fetch(`${API_BASE}/api/orders`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (!response.ok) {
//         const msg =
//           data.message ||
//           (data.errors ? JSON.stringify(data.errors) : "Failed to create order");
//         throw new Error(msg);
//       }

//       addToast("Order created successfully!", "success");
//       await fetchOrders();
//       return { success: true };
//     } catch (err) {
//       console.error("Create order error:", err);
//       setError(err.message);
//       addToast(err.message, "error");
//       return { success: false, error: err.message };
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------- Update order ----------
//   const updateOrder = async (orderId, orderData) => {
//     setLoading(true);
//     try {
//       const payload = {
//         panchayat_name: orderData.panchayat_name || orderData.customer?.name,
//         panchayat_taluk:
//           orderData.panchayat_taluk || orderData.panchayat?.taluk,
//         panchayat_district:
//           orderData.panchayat_district || orderData.panchayat?.district,
//         panchayat_state: orderData.panchayat_state || "Karnataka",

//         items: orderData.items.map((item) => ({
//           sku: item.sku,
//           quantity: Number(item.quantity || item.qty),
//           unit_price: Number(item.unit_price || item.price),
//         })),

//         total_amount: orderData.total_amount,
//         order_status: orderData.status || orderData.order_status,

//         shipping_address: orderData.shipping_address || {
//           panchayat: orderData.panchayat_name || orderData.customer?.name,
//           taluk: orderData.panchayat_taluk || orderData.panchayat?.taluk,
//           district: orderData.panchayat_district || orderData.panchayat?.district,
//           state: "Karnataka",
//         },
//       };

//       const response = await fetch(`${API_BASE}/api/orders/${orderId}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (!response.ok) throw new Error(data.message || "Failed to update order");

//       addToast("Order updated successfully!", "success");
//       await fetchOrders();
//       return { success: true };
//     } catch (err) {
//       console.error("Update order error:", err);
//       setError(err.message);
//       addToast(err.message, "error");
//       return { success: false, error: err.message };
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------- Delete order ----------
//   const deleteOrder = async (orderId) => {
//     const reason = window.prompt(
//       "Please enter a reason for deleting this order (optional):",
//       ""
//     );
//     if (reason === null) return;
//     if (!window.confirm("Are you sure you want to delete this order?")) return;

//     setLoading(true);
//     try {
//       const response = await fetch(`${API_BASE}/api/orders/${orderId}`, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ reason: reason.trim() || "No reason provided" }),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to delete order");
//       }

//       setOrders((prev) => prev.filter((o) => o.id !== orderId));
//       addToast("Order moved to trash successfully!", "success");
//     } catch (e) {
//       console.error("Delete error:", e);
//       addToast(e.message || "Failed to delete order", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------- UI Handlers ----------
//   const handleAddOrderClick = () => {
//     setEditingOrder(null);
//     setPreSelectedPanchayat(null);
//     setMode("form");
//   };

//   // const handleEditOrder = async (order) => {
//   //   setLoading(true);
//   //   try {
//   //     const fullOrder = await fetchOrderDetails(order.id);

//   //     if (fullOrder) {
//   //       let shippingAddress = fullOrder.shippingAddress;
//   //       if (typeof shippingAddress === "string") {
//   //         try {
//   //           shippingAddress = JSON.parse(shippingAddress);
//   //         } catch {
//   //           shippingAddress = {};
//   //         }
//   //       }

//   //       const editOrder = {
//   //         id: fullOrder.orderId,
//   //         orderNumber: `ORD-${fullOrder.orderId.substring(0, 8).toUpperCase()}`,
//   //         customer: {
//   //           id: fullOrder.customerId,
//   //           name: fullOrder.customerName,
//   //           email: fullOrder.customerEmail,
//   //           phone: fullOrder.customerPhone,
//   //         },
//   //         panchayat: {
//   //           id: fullOrder.panchayathId,
//   //           name: fullOrder.customerName || shippingAddress?.panchayat,
//   //           taluk: shippingAddress?.taluk || "",
//   //           district: shippingAddress?.district || "",
//   //           state: shippingAddress?.state || "Karnataka",
//   //         },
//   //         items: fullOrder.items.map((item) => ({
//   //           id: item.productId || item.sku,
//   //           product_id: item.productId,
//   //           sku: item.sku,
//   //           name: item.productName,
//   //           product_name: item.productName,
//   //           price: Number(item.basePrice || item.unitPrice),
//   //           unit_price: Number(item.basePrice || item.unitPrice),
//   //           qty: Number(item.quantity),
//   //           quantity: Number(item.quantity),
//   //           image: item.imageUrl,
//   //           image_url: item.imageUrl,
//   //         })),
//   //         status: fullOrder.orderStatus,
//   //         total: fullOrder.totalAmount,
//   //         shippingAddress: shippingAddress,
//   //       };

//   //       setEditingOrder(editOrder);
//   //       setPreSelectedPanchayat(null);
//   //       setMode("form");
//   //     } else {
//   //       addToast("Failed to load order details", "error");
//   //     }
//   //   } catch (err) {
//   //     console.error("Error loading order for edit:", err);
//   //     addToast("Failed to load order details", "error");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };


//   const handleEditOrder = async (order) => {
//   setLoading(true);
//   try {
//     const fullOrder = await fetchOrderDetails(order.id);

//     if (fullOrder) {
//       let shippingAddress = fullOrder.shippingAddress;
//       if (typeof shippingAddress === "string") {
//         try {
//           shippingAddress = JSON.parse(shippingAddress);
//         } catch {
//           shippingAddress = {};
//         }
//       }

//       const editOrder = {
//         id: fullOrder.orderId,
//         orderNumber: `ORD-${fullOrder.orderId.substring(0, 8).toUpperCase()}`,
//         customer: {
//           id: fullOrder.customerId,
//           name: fullOrder.customerName,
//           email: fullOrder.customerEmail,
//           phone: fullOrder.customerPhone,
//         },
//         panchayat: {
//           id: fullOrder.panchayathId,
//           name: fullOrder.customerName || shippingAddress?.panchayat,
//           taluk: shippingAddress?.taluk || "",
//           district: shippingAddress?.district || "",
//           state: shippingAddress?.state || "Karnataka",
//         },
//         // ✅ FIXED: Use unitPrice (order's saved price) first, then basePrice as fallback
//         items: fullOrder.items.map((item) => ({
//           id: item.productId || item.sku,
//           product_id: item.productId,
//           sku: item.sku,
//           name: item.productName,
//           product_name: item.productName,
//           // ✅ FIXED ORDER: unitPrice first (the negotiated/saved price)
//           price: Number(item.unitPrice || item.unit_price || item.basePrice || 0),
//           unit_price: Number(item.unitPrice || item.unit_price || item.basePrice || 0),
//           // ✅ NEW: Include original price for comparison
//           originalPrice: Number(item.basePrice || item.base_price || item.unitPrice || 0),
//           original_price: Number(item.basePrice || item.base_price || item.unitPrice || 0),
//           qty: Number(item.quantity),
//           quantity: Number(item.quantity),
//           image: item.imageUrl,
//           image_url: item.imageUrl,
//         })),
//         status: fullOrder.orderStatus,
//         total: fullOrder.totalAmount,
//         shippingAddress: shippingAddress,
//       };

//       console.log("Loaded order for editing:", editOrder); // Debug log

//       setEditingOrder(editOrder);
//       setPreSelectedPanchayat(null);
//       setMode("form");
//     } else {
//       addToast("Failed to load order details", "error");
//     }
//   } catch (err) {
//     console.error("Error loading order for edit:", err);
//     addToast("Failed to load order details", "error");
//   } finally {
//     setLoading(false);
//   }
// };
//   const handleViewOrder = async (order) => {
//     setLoading(true);
//     const fullOrder = await fetchOrderDetails(order.id);
//     setLoading(false);

//     if (fullOrder) {
//       const formatAddress = (addr) => {
//         if (!addr) return "-";
//         if (typeof addr === "string") {
//           try {
//             addr = JSON.parse(addr);
//           } catch {
//             return addr;
//           }
//         }
//         const parts = [
//           addr.street,
//           addr.landmark,
//           addr.panchayat,
//           addr.taluk,
//           addr.district,
//           addr.state,
//           addr.pincode,
//         ].filter(Boolean);
//         return parts.length > 0 ? parts.join(", ") : "-";
//       };

//       setViewingOrder({
//         id: fullOrder.orderId,
//         orderNumber: `ORD-${fullOrder.orderId.substring(0, 8).toUpperCase()}`,

//         customer: {
//           name: fullOrder.customerName,
//           email: fullOrder.customerEmail,
//           phone: fullOrder.customerPhone,
//           address: formatAddress(fullOrder.shippingAddress),
//         },
//         customerName: fullOrder.customerName,
//         customerEmail: fullOrder.customerEmail,
//         customerPhone: fullOrder.customerPhone,
//         panchayathPincode: fullOrder.panchayathPincode,

//         items: fullOrder.items.map((i) => ({
//           sku: i.sku,
//           name: i.productName,
//           price: i.basePrice,
//           qty: i.quantity,
//           subtotal: i.subtotal,
//           image: i.imageUrl,
//           imageUrl: i.imageUrl,
//           image_url: i.imageUrl,
//           taxClass: i.taxClass,
//           gstRate: i.gstRate,
//           gstAmount: i.gstAmount,
//           vatPercentage: i.vatPercentage,
//           vatAmount: i.vatAmount,
//         })),

//         status: fullOrder.orderStatus,
//         paymentStatus: fullOrder.paymentStatus || fullOrder.payment_status || "UNPAID",
//         dateLabel: formatDateLabel(fullOrder.createdAt),

//         subtotal: fullOrder.subtotal,
//         gstAmount: fullOrder.gstAmount,
//         gstPercentage: fullOrder.gstPercentage,
//         vatAmount: fullOrder.vatAmount,
//         vatPercentage: fullOrder.vatPercentage,
//         taxAmount: fullOrder.taxAmount || 0,
//         total: fullOrder.totalAmount,
//         totalAmount: fullOrder.totalAmount,
//         grandTotal: fullOrder.totalAmount,
//         shippingRate: fullOrder.shippingRate || 0,
//         shippingAddress: fullOrder.shippingAddress,
//         shippingAddressFormatted: fullOrder.shippingAddressFormatted,

//         statusHistory:
//           fullOrder.statusHistory || fullOrder.status_history || {},
//       });

//       setMode("view");
//     }
//   };

//   const handleCancelForm = () => {
//     setEditingOrder(null);
//     setPreSelectedPanchayat(null);
//     setMode("table");
//   };

//   const handleCloseDetails = () => {
//     setViewingOrder(null);
//     setMode("table");
//     fetchOrders();
//   };

//   const handleSaveOrder = async (draft) => {
//     const result = draft.id
//       ? await updateOrder(draft.id, draft)
//       : await createOrder(draft);

//     if (result.success) {
//       setCurrentPage(1);
//       setEditingOrder(null);
//       setPreSelectedPanchayat(null);
//       setMode("table");
//     }
//   };

//   const handleClearFilters = () => {
//     setFilters(defaultLocationFilters);
//     setTaluks([]);
//     setPanchayats([]);
//   };

//   // ---------- View Mode ----------
//   if (mode === "view" && viewingOrder) {
//     return (
//       <>
//         <div className="toast-container">
//           {toasts.map((t) => (
//             <Toast
//               key={t.id}
//               message={t.message}
//               type={t.type}
//               onClose={() => removeToast(t.id)}
//             />
//           ))}
//         </div>
//         <OrderDetails
//           order={viewingOrder}
//           onBack={handleCloseDetails}
//           onStatusChange={updateOrderStatus}
//           onPaymentStatusChange={updatePaymentStatus}
//         />
//       </>
//     );
//   }

//   // ---------- Form Mode ----------
//   if (mode === "form") {
//     return (
//       <>
//         <div className="toast-container">
//           {toasts.map((t) => (
//             <Toast
//               key={t.id}
//               message={t.message}
//               type={t.type}
//               onClose={() => removeToast(t.id)}
//             />
//           ))}
//         </div>
//         <OrderForm
//           initialOrder={editingOrder}
//           preSelectedPanchayat={preSelectedPanchayat}
//           onCancel={handleCancelForm}
//           onSave={handleSaveOrder}
//           loading={loading}
//           error={error}
//         />
//       </>
//     );
//   }

//   // ---------- Table Mode ----------
//   return (
//     <div className="orders-page">
//       <div className="toast-container">
//         {toasts.map((t) => (
//           <Toast
//             key={t.id}
//             message={t.message}
//             type={t.type}
//             onClose={() => removeToast(t.id)}
//           />
//         ))}
//       </div>

//       {error && (
//         <div className="error-toast">
//           {error}
//           <button onClick={() => setError(null)}>×</button>
//         </div>
//       )}

//       <div className="orders-header">
//         <div className="orders-header-top">
//           <div className="orders-header-left">
//             <h1 className="orders-title">Order</h1>
//             <div className="orders-breadcrumbs">
//               <span className="breadcrumb-link">Dashboard</span>
//               <FiChevronRight className="breadcrumb-separator-icon" />
//               <span className="breadcrumb-current">Order List</span>
//             </div>
//           </div>

//           <div className="orders-header-right">
//             <button
//               className="btn btn-icon-only"
//               onClick={fetchOrders}
//               title="Refresh"
//               disabled={loading}
//             >
//               <FiRefreshCw className={loading ? "spinning" : ""} />
//             </button>

//             <button
//               className="btn btn-outline btn-trash"
//               onClick={() => (window.location.href = "/orders/deleted")}
//               title="View Deleted Orders"
//             >
//               <FiTrash2 className="btn-icon" />
//               <span>Trash</span>
//             </button>

//             <button className="btn btn-outline">
//               <BiExport className="btn-icon" />
//               <span>Export</span>
//             </button>

//             <button className="btn btn-primary" onClick={handleAddOrderClick}>
//               <FiPlus className="btn-icon" />
//               <span>Add Order</span>
//             </button>
//           </div>
//         </div>

//         <div className="orders-header-bottom">
//           <div className="orders-tabs">
//             {RANGE_TABS.map((tab) => (
//               <button
//                 key={tab.key}
//                 className={`orders-tab ${activeRange === tab.key ? "active" : ""}`}
//                 onClick={() => setActiveRange(tab.key)}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>

//           <div className="orders-header-bottom-right" ref={filterAreaRef}>
//             <button
//               type="button"
//               className={`btn btn-outline header-filter-btn ${isDateFilterActive ? "active" : ""}`}
//               onClick={() => setShowDatePopover((v) => !v)}
//               title="Select dates"
//             >
//               <FiCalendar className="btn-icon" />
//               <span>Select Dates</span>
//             </button>

//             <button
//               type="button"
//               className={`filters-btn ${showFilters ? "active" : ""} ${hasActiveFilters ? "has-filters" : ""}`}
//               onClick={() => setShowFilters((prev) => !prev)}
//               title="Filters"
//             >
//               <FiFilter className="filters-icon" />
//               <span>Filters</span>
//               {activeFilterCount > 0 && (
//                 <span className="filter-count-badge">{activeFilterCount}</span>
//               )}
//             </button>

//             {/* Date popover */}
//             {showDatePopover && (
//               <div className="orders-popover">
//                 <div className="orders-popover-grid">
//                   <div>
//                     <label>Start date</label>
//                     <input
//                       type="date"
//                       value={dateDraft.start}
//                       onChange={(e) =>
//                         setDateDraft((p) => ({ ...p, start: e.target.value }))
//                       }
//                     />
//                   </div>

//                   <div>
//                     <label>End date</label>
//                     <input
//                       type="date"
//                       value={dateDraft.end}
//                       onChange={(e) =>
//                         setDateDraft((p) => ({ ...p, end: e.target.value }))
//                       }
//                     />
//                   </div>
//                 </div>

//                 <div className="orders-popover-actions">
//                   <button
//                     className="btn btn-outline"
//                     type="button"
//                     onClick={clearDateFilter}
//                   >
//                     Clear
//                   </button>
//                   <button
//                     className="btn btn-primary"
//                     type="button"
//                     onClick={applyDateFilter}
//                   >
//                     Apply
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Filters panel - Updated with multi-select and new filters */}
//         {showFilters && (
//           <div className="orders-filter-panel">
//             <div className="filter-panel-content">
//               {/* District - Multi-select */}
//               <div className="filter-group">
//                 <label className="filter-label">District</label>
//                 <MultiSelectDropdown
//                   options={districts.map((d) => ({ value: d.name, label: d.name }))}
//                   selectedValues={filters.districts}
//                   onChange={(values) =>
//                     setFilters((p) => ({ ...p, districts: values }))
//                   }
//                   placeholder="All Districts"
//                 />
//               </div>

//               {/* Taluk - Multi-select */}
//               <div className="filter-group">
//                 <label className="filter-label">Taluk</label>
//                 <MultiSelectDropdown
//                   options={taluks.map((t) => ({ value: t.name, label: t.name }))}
//                   selectedValues={filters.taluks}
//                   onChange={(values) =>
//                     setFilters((p) => ({ ...p, taluks: values }))
//                   }
//                   disabled={filters.districts.length === 0}
//                   placeholder="All Taluks"
//                 />
//               </div>

//               {/* Panchayat - Multi-select */}
//               <div className="filter-group">
//                 <label className="filter-label">Panchayat</label>
//                 <MultiSelectDropdown
//                   options={panchayatOptions.map((name) => ({ value: name, label: name }))}
//                   selectedValues={filters.panchayats}
//                   onChange={(values) =>
//                     setFilters((p) => ({ ...p, panchayats: values }))
//                   }
//                   disabled={filters.districts.length === 0}
//                   placeholder="All Panchayats"
//                 />
//               </div>

//               {/* Order Status - Single select (renamed from Status) */}
//               <div className="filter-group">
//                 <label className="filter-label">Order Status</label>
//                 <select
//                   className="orders-filter-select"
//                   value={filters.orderStatus}
//                   onChange={(e) =>
//                     setFilters((p) => ({ ...p, orderStatus: e.target.value }))
//                   }
//                 >
//                   {ORDER_STATUS_OPTIONS.map((s) => (
//                     <option key={s} value={s}>
//                       {s === "all" ? "All" : s}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Payment Status - New filter */}
//               <div className="filter-group">
//                 <label className="filter-label">Payment Status</label>
//                 <select
//                   className="orders-filter-select"
//                   value={filters.paymentStatus}
//                   onChange={(e) =>
//                     setFilters((p) => ({ ...p, paymentStatus: e.target.value }))
//                   }
//                 >
//                   {PAYMENT_STATUS_OPTIONS.map((s) => (
//                     <option key={s} value={s}>
//                       {s === "all" ? "All" : s}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="filter-actions">
//                 <button
//                   type="button"
//                   className="filter-clear-btn"
//                   onClick={handleClearFilters}
//                   disabled={!hasActiveFilters}
//                 >
//                   Clear All
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="orders-card-list">
//         {loading && (
//           <div className="loading-overlay">
//             <div className="loading-spinner"></div>
//           </div>
//         )}

//         <div className="orders-table-wrapper">
//           <table className="orders-table">
//             <thead>
//               <tr>
//                 <th className="col-order-id">
//                   <div className="order-header-cell">
//                     <input type="checkbox" />
//                     <span>Order ID</span>
//                   </div>
//                 </th>
//                 <th className="col-product">
//                   <span>Product</span>
//                 </th>
//                 <th className="col-date">
//                   <span>Date</span>
//                 </th>
//                  <th className="col-date">
//                   <span>Taluk</span>
//                 </th>
//                 <th className="col-customer">
//                   <span>Customer</span>
//                 </th>
//                 <th className="col-total">
//                   <span>Total</span>
//                 </th>
//                 <th className="col-status">
//                   <span>Status</span>
//                 </th>
//                 <th className="col-action">
//                   <span>Action</span>
//                 </th>
//               </tr>
//             </thead>

//             <tbody>
//               {!loading && totalItems === 0 ? (
//                 <tr>
//                   <td colSpan={8} className="empty-table-cell">
//                     No orders yet.
//                   </td>
//                 </tr>
//               ) : (
//                 currentItems.map((order, index) => {
//                   const additionalItems =
//                     order.itemsCount > 1 ? order.itemsCount - 1 : 0;

//                   return (
//                     <tr key={order.id || `ord-${index}`}>
//                       <td className="col-order-id" data-label="Order ID">
//                         <div className="order-id-cell">
//                           <input type="checkbox" className="row-checkbox" />
//                           <button
//                             className="order-id-link"
//                             onClick={() => handleViewOrder(order)}
//                           >
//                             {order.orderNumber}
//                           </button>
//                         </div>
//                       </td>

//                       <td className="col-product">
//                         <div className="product-preview-cell">
//                           <div className="product-thumbnail">
//                             {order.firstItemImage ? (
//                               <img
//                                 src={order.firstItemImage}
//                                 alt={order.firstItemName || "Product"}
//                                 className="product-thumb-img"
//                                 onError={(e) => {
//                                   e.target.style.display = "none";
//                                   e.target.nextSibling.style.display = "flex";
//                                 }}
//                               />
//                             ) : null}
//                             <div
//                               className="product-thumb-placeholder"
//                               style={{
//                                 display: order.firstItemImage ? "none" : "flex",
//                               }}
//                             >
//                               <FiPackage />
//                             </div>
//                           </div>

//                           <div className="product-preview-info">
//                             <div className="product-preview-name">
//                               {order.firstItemName || "No Product"}
//                             </div>
//                             {additionalItems > 0 && (
//                               <div className="product-preview-more">
//                                 +{additionalItems} more item
//                                 {additionalItems > 1 ? "s" : ""}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </td>

//                       <td className="col-date" data-label="Date">
//                         {order.dateLabel}
//                       </td>
//                       <td className="col-taluk" data-label="Taluk">
//                         <span className="taluk-text" title={order.taluk || "-"}>
//                           {order.taluk || "-"}
//                         </span>
//                       </td>
//                       <td className="col-customer" data-label="Customer">
//                         <div className="customer-line">
//                           <span className="customer-name">
//                             {order.customer.name}
//                           </span>
//                           <span
//                             className="customer-email"
//                             title={order.customer.email}
//                           >
//                             {truncateEmail(order.customer.email, 10)}
//                           </span>
//                         </div>
//                       </td>

//                       <td className="col-total" data-label="Total">
//                         {formatINR(order.total)}
//                       </td>

//                       <td className="col-status">
//                         <span
//                           className={`status-pill ${getStatusClass(order.status)}`}
//                         >
//                           {order.status}
//                         </span>
//                       </td>

//                       <td className="col-action">
//                         <div className="action-buttons2">
//                           <button
//                             className="icon-button small"
//                             onClick={() => handleViewOrder(order)}
//                             title="View Order"
//                           >
//                             <FiEye />
//                           </button>
//                           <button
//                             className="icon-button small"
//                             onClick={() => handleEditOrder(order)}
//                             title="Edit Order"
//                           >
//                             <FiEdit2 />
//                           </button>
//                           <button
//                             className="icon-button small danger"
//                             onClick={() => deleteOrder(order.id)}
//                             title="Delete Order"
//                             disabled={loading}
//                           >
//                             <FiTrash2 />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>

//         {totalItems > 0 && (
//           <div className="orders-pagination">
//             <div className="pagination-info">
//               Showing {startIndex + 1}-
//               {Math.min(startIndex + PAGE_SIZE, totalItems)} of {totalItems}
//             </div>
//             <div className="pagination-controls">
//               <button
//                 className="page-button"
//                 onClick={() => changePage(safePage - 1)}
//                 disabled={safePage === 1}
//               >
//                 ‹
//               </button>
//               {Array.from({ length: totalPages }, (_, i) => (
//                 <button
//                   key={`pg-${i}`}
//                   className={`page-button ${i + 1 === safePage ? "active" : ""}`}
//                   onClick={() => changePage(i + 1)}
//                 >
//                   {i + 1}
//                 </button>
//               ))}
//               <button
//                 className="page-button"
//                 onClick={() => changePage(safePage + 1)}
//                 disabled={safePage === totalPages}
//               >
//                 ›
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrdersList;

import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import "./ordersList.css";
import {
  FiPlus,
  FiChevronRight,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiRefreshCw,
  FiPackage,
  FiCheck,
  FiX,
  FiCalendar,
  FiFilter,
  FiChevronDown,
} from "react-icons/fi";
import { BiExport } from "react-icons/bi";
import OrderForm from "./orderForm";
import OrderDetails from "./orderDetails";

const API_BASE = process.env.REACT_APP_EP || "http://localhost:5000";

const RANGE_TABS = [
  { key: "all", label: "All Time" },
  { key: "12m", label: "12 Months" },
  { key: "30d", label: "30 Days" },
  { key: "7d", label: "7 Days" },
  { key: "24h", label: "24 Hour" },
];

const PAGE_SIZE = 10;

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 2,
});
const formatINR = (value) => inrFormatter.format(value ?? 0);

const formatDateLabel = (dateString) => {
  if (!dateString) return "-";
  try {
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "-";
  }
};

const getDateRangeParams = (rangeKey) => {
  const now = new Date();
  let startDate = null;

  switch (rangeKey) {
    case "24h":
      startDate = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      break;
    case "7d":
      startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      break;
    case "30d":
      startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      break;
    case "12m":
      startDate = new Date(
        now.getFullYear() - 1,
        now.getMonth(),
        now.getDate()
      );
      break;
    default:
      return {};
  }

  return {
    start_date: startDate?.toISOString(),
    end_date: now.toISOString(),
  };
};

const getStatusClass = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "processing") return "status-processing";
  if (s === "shipped" || s === "shipping") return "status-shipped";
  if (s === "delivered") return "status-delivered";
  if (s === "packed") return "status-packed";
  if (s === "cancelled" || s === "canceled") return "status-cancelled";
  return "status-pending";
};

const truncateEmail = (email, maxLength = 10) => {
  if (!email) return "";
  return email.length > maxLength ? email.slice(0, maxLength) + "..." : email;
};

const parseMaybeJson = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const normalizeLocationFromOrder = (order) => {
  const addr =
    parseMaybeJson(order.shippingAddress) ||
    parseMaybeJson(order.shipping_address) ||
    order.shippingAddress ||
    order.shipping_address ||
    null;

  const district =
    order?.panchayat_district ||
    order?.panchayatDistrict ||
    addr?.district ||
    "";

  const taluk =
    order?.panchayat_taluk ||
    order?.panchayatTaluk ||
    addr?.taluk ||
    "";

  const panchayat =
    order?.panchayat_name ||
    order?.panchayatName ||
    addr?.panchayat ||
    order?.customerName ||
    "";

  return { district, taluk, panchayat };
};

// Toast Notification Component
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-icon">
        {type === "success" ? <FiCheck /> : <FiX />}
      </div>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
};

// Multi-Select Dropdown Component with Checklist
const MultiSelectDropdown = ({
  label,
  options,
  selectedValues,
  onChange,
  disabled,
  placeholder = "Select...",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = (value) => {
    if (selectedValues.includes(value)) {
      onChange(selectedValues.filter((v) => v !== value));
    } else {
      onChange([...selectedValues, value]);
    }
  };

  const handleSelectAll = () => {
    if (selectedValues.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map((opt) => opt.value || opt));
    }
  };

  const getDisplayText = () => {
    if (selectedValues.length === 0) return placeholder;
    if (selectedValues.length === 1) {
      const opt = options.find((o) => (o.value || o) === selectedValues[0]);
      return opt?.label || opt?.name || selectedValues[0];
    }
    return `${selectedValues.length} selected`;
  };

  return (
    <div
      className={`multi-select-dropdown ${disabled ? "disabled" : ""}`}
      ref={dropdownRef}
    >
      <button
        type="button"
        className={`multi-select-trigger ${isOpen ? "open" : ""}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <span className="multi-select-text">{getDisplayText()}</span>
        <FiChevronDown className={`multi-select-arrow ${isOpen ? "rotated" : ""}`} />
      </button>

      {isOpen && !disabled && (
        <div className="multi-select-menu">
          {options.length > 0 && (
            <div className="multi-select-item select-all" onClick={handleSelectAll}>
              <div className={`custom-checkbox ${selectedValues.length === options.length ? "checked" : ""}`}>
                {selectedValues.length === options.length && <FiCheck />}
              </div>
              <span>Select All</span>
            </div>
          )}
          
          <div className="multi-select-options">
            {options.length === 0 ? (
              <div className="multi-select-empty">No options available</div>
            ) : (
              options.map((option) => {
                const value = option.value || option.name || option;
                const labelText = option.label || option.name || option;
                const isSelected = selectedValues.includes(value);

                return (
                  <div
                    key={value}
                    className={`multi-select-item ${isSelected ? "selected" : ""}`}
                    onClick={() => handleToggle(value)}
                  >
                    <div className={`custom-checkbox ${isSelected ? "checked" : ""}`}>
                      {isSelected && <FiCheck />}
                    </div>
                    <span>{labelText}</span>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const ORDER_STATUS_OPTIONS = [
  "all",
  "PLACED",
  "PROCESSING",
  "PACKED",
  "SHIPPED",
  "DELIVERED",
  "CANCELLED",
];

const PAYMENT_STATUS_OPTIONS = [
  "all",
  "PAID",
  "UNPAID",
  "PARTIAL PAID",
];

const defaultLocationFilters = {
  districts: [],
  taluks: [],
  panchayats: [],
  orderStatus: "all",
  paymentStatus: "all",
};

const normalizeText = (v) => (v || "").toString().trim().toLowerCase();

const OrdersList = () => {
  const [mode, setMode] = useState("table");
  const [orders, setOrders] = useState([]);
  const [editingOrder, setEditingOrder] = useState(null);
  const [viewingOrder, setViewingOrder] = useState(null);
  const [preSelectedPanchayat, setPreSelectedPanchayat] = useState(null);

  const [activeRange, setActiveRange] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [toasts, setToasts] = useState([]);

  const [showDatePopover, setShowDatePopover] = useState(false);
  const [dateDraft, setDateDraft] = useState({ start: "", end: "" });
  const [dateFilter, setDateFilter] = useState({ start: "", end: "" });

  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState(defaultLocationFilters);

  const [districts, setDistricts] = useState([]);
  const [taluks, setTaluks] = useState([]);
  const [panchayats, setPanchayats] = useState([]);

  const filterAreaRef = useRef(null);

  const isDateFilterActive = Boolean(dateFilter.start || dateFilter.end);

  const hasActiveFilters =
    filters.districts.length > 0 ||
    filters.taluks.length > 0 ||
    filters.panchayats.length > 0 ||
    filters.orderStatus !== "all" ||
    filters.paymentStatus !== "all";

  const activeFilterCount = [
    filters.districts.length > 0,
    filters.taluks.length > 0,
    filters.panchayats.length > 0,
    filters.orderStatus !== "all",
    filters.paymentStatus !== "all",
  ].filter(Boolean).length;

  const addToast = useCallback((message, type = "success") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const applyDateFilter = () => {
    setDateFilter(dateDraft);
    setCurrentPage(1);
    setShowDatePopover(false);
  };

  const clearDateFilter = () => {
    setDateDraft({ start: "", end: "" });
    setDateFilter({ start: "", end: "" });
    setCurrentPage(1);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!filterAreaRef.current) return;
      if (!filterAreaRef.current.contains(e.target)) {
        setShowDatePopover(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const storedPanchayat = sessionStorage.getItem("selectedPanchayat");
    const orderAction = sessionStorage.getItem("orderAction");

    if (storedPanchayat && orderAction === "salesOrder") {
      try {
        const panchayat = JSON.parse(storedPanchayat);
        setPreSelectedPanchayat(panchayat);
        setEditingOrder(null);
        setMode("form");

        sessionStorage.removeItem("selectedPanchayat");
        sessionStorage.removeItem("orderAction");
      } catch (e) {
        console.error("Error parsing stored panchayat:", e);
      }
    }
  }, []);

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/locations/districts`);
        const data = await res.json();
        if (data?.success) setDistricts(data.data || []);
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };
    fetchDistricts();
  }, []);

  const fetchPanchayathsList = useCallback(
    async (districtNames, talukNames) => {
      if (!districtNames || districtNames.length === 0) {
        setPanchayats([]);
        return;
      }
      try {
        const allPanchayats = [];
        
        for (const districtName of districtNames) {
          const params = new URLSearchParams({
            page: "1",
            limit: "1000",
            district: districtName,
          });
          
          if (talukNames && talukNames.length > 0) {
            for (const talukName of talukNames) {
              params.set("taluk", talukName);
              
              const token = sessionStorage.getItem("authToken");
              const headers = {};
              if (token) headers["Authorization"] = `Bearer ${token}`;

              const res = await fetch(
                `${API_BASE}/api/panchayaths/fetch?${params.toString()}`,
                { headers }
              );
              const data = await res.json();

              if (res.ok && data && data.success !== false) {
                const list = Array.isArray(data.data?.panchayaths)
                  ? data.data.panchayaths
                  : [];
                allPanchayats.push(...list);
              }
            }
          } else {
            const token = sessionStorage.getItem("authToken");
            const headers = {};
            if (token) headers["Authorization"] = `Bearer ${token}`;

            const res = await fetch(
              `${API_BASE}/api/panchayaths/fetch?${params.toString()}`,
              { headers }
            );
            const data = await res.json();

            if (res.ok && data && data.success !== false) {
              const list = Array.isArray(data.data?.panchayaths)
                ? data.data.panchayaths
                : [];
              allPanchayats.push(...list);
            }
          }
        }

        const uniquePanchayats = Array.from(
          new Map(allPanchayats.map((p) => [p.name || p.panchayat, p])).values()
        );

        const mapped = uniquePanchayats
          .map((p) => ({
            name: p.name || p.panchayat || "",
            taluk: p.taluk || "",
            district: p.district || "",
          }))
          .filter((p) => p.name);

        setPanchayats(mapped);
      } catch (err) {
        console.error("Error fetching panchayaths:", err);
        setPanchayats([]);
      }
    },
    []
  );

  useEffect(() => {
    const selectedDistricts = filters.districts;

    const fetchTaluks = async (districtNames) => {
      if (!districtNames || districtNames.length === 0) {
        setTaluks([]);
        return;
      }
      try {
        const allTaluks = [];
        for (const district of districtNames) {
          const res = await fetch(
            `${API_BASE}/api/locations/taluks?district=${encodeURIComponent(district)}`
          );
          const data = await res.json();
          if (data?.success) {
            allTaluks.push(...(data.data || []));
          }
        }
        const uniqueTaluks = Array.from(
          new Map(allTaluks.map((t) => [t.name, t])).values()
        );
        setTaluks(uniqueTaluks);
      } catch (err) {
        console.error("Error fetching taluks:", err);
        setTaluks([]);
      }
    };

    setTaluks([]);
    setPanchayats([]);
    setFilters((prev) => ({
      ...prev,
      taluks: [],
      panchayats: [],
    }));

    if (selectedDistricts.length === 0) return;

    fetchTaluks(selectedDistricts);
    fetchPanchayathsList(selectedDistricts, []);
  }, [filters.districts, fetchPanchayathsList]);

  useEffect(() => {
    const selectedDistricts = filters.districts;
    const selectedTaluks = filters.taluks;

    setFilters((prev) => ({
      ...prev,
      panchayats: [],
    }));

    if (selectedDistricts.length === 0) {
      setPanchayats([]);
      return;
    }

    fetchPanchayathsList(selectedDistricts, selectedTaluks);
  }, [filters.taluks, filters.districts, fetchPanchayathsList]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filters, dateFilter]);

  // ---------- Fetch orders ----------
  const fetchOrders = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const params = getDateRangeParams(activeRange);
      const queryString = new URLSearchParams(params).toString();
      const url = `${API_BASE}/api/orders${queryString ? `?${queryString}` : ""}`;

      const response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error("Failed to fetch orders");

      const data = await response.json();
      const ordersList = data.data || data.orders || [];

      console.log("Fetched orders from API:", ordersList); // Debug log

      const transformed = ordersList.map((order) => {
        const { district, taluk, panchayat } = normalizeLocationFromOrder(order);

        return {
          id: order.orderId,
          orderNumber: `ORD-${(order.orderId || "")
            .toString()
            .substring(0, 8)
            .toUpperCase()}`,
          total: Number(order.totalAmount || 0),
          status: order.orderStatus || "PENDING",
          paymentStatus: order.paymentStatus || "UNPAID",
          date: order.createdAt,
          dateLabel: formatDateLabel(order.createdAt),
          customer: {
            name: order.customerName || "Unknown",
            email: order.customerEmail || "",
            phone: order.customerPhone || "",
          },
          itemsCount: order.itemsCount || 0,
          totalItemsQuantity: order.totalItems || 0,
          firstItemName: order.firstItemName || null,
          firstItemImage: order.firstItemImage || null,
          firstItemSku: order.firstItemSku || null,
          items: [],
          district,
          taluk,
          panchayat,
        };
      });

      setOrders(transformed);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching orders:", err);
    } finally {
      setLoading(false);
    }
  }, [activeRange]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const panchayatOptions = useMemo(() => {
    if (filters.districts.length === 0) return [];
    const names = panchayats.map((p) => p.name).filter(Boolean);
    return Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
  }, [panchayats, filters.districts]);

  const filteredOrders = useMemo(() => {
    let list = [...orders];

    if (dateFilter.start || dateFilter.end) {
      const start = dateFilter.start
        ? new Date(`${dateFilter.start}T00:00:00`)
        : null;
      const end = dateFilter.end
        ? new Date(`${dateFilter.end}T23:59:59.999`)
        : null;

      list = list.filter((o) => {
        const d = o?.date ? new Date(o.date) : null;
        if (!d || isNaN(d.getTime())) return false;
        if (start && d < start) return false;
        if (end && d > end) return false;
        return true;
      });
    }

    const getOrderPanchayatName = (o) => normalizeText(o?.customer?.name);

    if (filters.panchayats.length > 0) {
      const targetPanchayats = filters.panchayats.map((p) => normalizeText(p));
      list = list.filter((o) => targetPanchayats.includes(getOrderPanchayatName(o)));
    } 
    else if (filters.taluks.length > 0) {
      const allowedPanchayats = panchayats
        .filter((p) => filters.taluks.includes(p.taluk))
        .map((p) => normalizeText(p.name));
      
      if (allowedPanchayats.length > 0) {
        list = list.filter((o) => allowedPanchayats.includes(getOrderPanchayatName(o)));
      }
    }
    else if (filters.districts.length > 0) {
      const allowedNames = new Set(
        panchayats.map((p) => normalizeText(p.name))
      );
      if (allowedNames.size > 0) {
        list = list.filter((o) => allowedNames.has(getOrderPanchayatName(o)));
      } else {
        list = [];
      }
    }

    if (filters.orderStatus && filters.orderStatus !== "all") {
      const sv = normalizeText(filters.orderStatus);
      list = list.filter((o) => normalizeText(o?.status) === sv);
    }

    if (filters.paymentStatus && filters.paymentStatus !== "all") {
      const pv = normalizeText(filters.paymentStatus);
      list = list.filter((o) => normalizeText(o?.paymentStatus) === pv);
    }

    return list;
  }, [orders, dateFilter, filters, panchayats]);

  const { currentItems, totalItems, totalPages, safePage, startIndex } =
    useMemo(() => {
      const total = filteredOrders.length;
      const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
      const safe = Math.min(currentPage, pages);
      const start = (safe - 1) * PAGE_SIZE;
      const slice = filteredOrders.slice(start, start + PAGE_SIZE);
      return {
        currentItems: slice,
        totalItems: total,
        totalPages: pages,
        safePage: safe,
        startIndex: start,
      };
    }, [filteredOrders, currentPage]);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ---------- Fetch single order details ----------
  const fetchOrderDetails = async (orderId) => {
    try {
      const response = await fetch(`${API_BASE}/api/orders/${orderId}`);
      if (response.ok) {
        const data = await response.json();
        console.log("Fetched order details:", data); // Debug log
        return data.data || data;
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  };

  // ---------- Update order status ----------
  const updateOrderStatus = useCallback(
    async (orderId, newStatus, updatedBy) => {
      try {
        const response = await fetch(
          `${API_BASE}/api/orders/${orderId}/status`,
          {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              order_status: newStatus,
              updatedBy,
            }),
          }
        );

        const data = await response.json();

        if (!response.ok || data.success === false) {
          throw new Error(data.message || "Failed to update order status");
        }

        const updatedOrder = data.data;

        setOrders((prev) =>
          prev.map((o) =>
            o.id === updatedOrder.orderId
              ? { ...o, status: updatedOrder.orderStatus || newStatus }
              : o
          )
        );

        setViewingOrder((prev) => {
          if (!prev || prev.id !== updatedOrder.orderId) return prev;
          return {
            ...prev,
            status: updatedOrder.orderStatus || newStatus,
            statusHistory:
              updatedOrder.statusHistory || updatedOrder.status_history || {},
          };
        });

        return updatedOrder;
      } catch (err) {
        console.error("Status update error:", err);
        addToast(err.message || "Failed to update status", "error");
        throw err;
      }
    },
    [addToast]
  );

  // ---------- Update payment status ----------
  const updatePaymentStatus = useCallback(
    async (orderId, newStatus, updatedBy) => {
      try {
        const response = await fetch(
          `${API_BASE}/api/orders/${orderId}/payment`,
          {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              payment_status: newStatus,
              updatedBy,
            }),
          }
        );

        const data = await response.json();

        if (!response.ok || data.success === false) {
          throw new Error(data.message || "Failed to update payment status");
        }

        const updatedOrder = data.data;

        setOrders((prev) =>
          prev.map((o) =>
            o.id === updatedOrder.orderId
              ? {
                  ...o,
                  paymentStatus:
                    updatedOrder.paymentStatus || updatedOrder.payment_status || newStatus,
                }
              : o
          )
        );

        setViewingOrder((prev) => {
          if (!prev || prev.id !== updatedOrder.orderId) return prev;
          return {
            ...prev,
            paymentStatus:
              updatedOrder.paymentStatus || updatedOrder.payment_status || newStatus,
            payment_status:
              updatedOrder.payment_status || updatedOrder.paymentStatus || newStatus,
          };
        });

        return updatedOrder;
      } catch (err) {
        console.error("Payment status update error:", err);
        addToast(err.message || "Failed to update payment status", "error");
        throw err;
      }
    },
    [addToast]
  );

  // ---------- Create order ----------
  const createOrder = async (orderData) => {
    setLoading(true);
    try {
      const payload = {
        panchayat_name: orderData.panchayat_name || orderData.customer_name,
        panchayat_taluk: orderData.panchayat_taluk || orderData.customer_taluk,
        panchayat_district:
          orderData.panchayat_district || orderData.customer_district,
        panchayat_state: orderData.panchayat_state || "Karnataka",

        items: orderData.items.map((item) => ({
          sku: item.sku,
          quantity: Number(item.quantity || item.qty),
          unit_price: Number(item.unit_price || item.price),
        })),

        total_amount: orderData.total_amount,
        tax_amount: orderData.tax_amount || 0,

        shipping_address: orderData.shipping_address || {
          panchayat: orderData.panchayat_name || orderData.customer_name,
          taluk: orderData.panchayat_taluk || orderData.customer_taluk,
          district: orderData.panchayat_district || orderData.customer_district,
          state: "Karnataka",
        },
      };

      console.log("Creating order with payload:", payload); // Debug log

      const response = await fetch(`${API_BASE}/api/orders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Create order response:", data); // Debug log
      
      if (!response.ok) {
        const msg =
          data.message ||
          (data.errors ? JSON.stringify(data.errors) : "Failed to create order");
        throw new Error(msg);
      }

      addToast("Order created successfully!", "success");
      await fetchOrders();
      return { success: true };
    } catch (err) {
      console.error("Create order error:", err);
      setError(err.message);
      addToast(err.message, "error");
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  // ---------- Update order ----------
  const updateOrder = async (orderId, orderData) => {
    setLoading(true);
    try {
      const payload = {
        panchayat_name: orderData.panchayat_name || orderData.customer?.name,
        panchayat_taluk:
          orderData.panchayat_taluk || orderData.panchayat?.taluk,
        panchayat_district:
          orderData.panchayat_district || orderData.panchayat?.district,
        panchayat_state: orderData.panchayat_state || "Karnataka",

        items: orderData.items.map((item) => ({
          sku: item.sku,
          quantity: Number(item.quantity || item.qty),
          unit_price: Number(item.unit_price || item.price),
        })),

        total_amount: orderData.total_amount,
        order_status: orderData.status || orderData.order_status,

        shipping_address: orderData.shipping_address || {
          panchayat: orderData.panchayat_name || orderData.customer?.name,
          taluk: orderData.panchayat_taluk || orderData.panchayat?.taluk,
          district: orderData.panchayat_district || orderData.panchayat?.district,
          state: "Karnataka",
        },
      };

      console.log("Updating order with payload:", payload); // Debug log

      const response = await fetch(`${API_BASE}/api/orders/${orderId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Update order response:", data); // Debug log
      
      if (!response.ok) throw new Error(data.message || "Failed to update order");

      // ✅ IMPORTANT: Update local state immediately with the new total
      const newTotal = orderData.total_amount;
      setOrders((prev) =>
        prev.map((o) =>
          o.id === orderId
            ? { ...o, total: newTotal }
            : o
        )
      );

      addToast("Order updated successfully!", "success");
      
      // Also refetch to ensure we have latest data
      await fetchOrders();
      
      return { success: true };
    } catch (err) {
      console.error("Update order error:", err);
      setError(err.message);
      addToast(err.message, "error");
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  // ---------- Delete order ----------
  const deleteOrder = async (orderId) => {
    const reason = window.prompt(
      "Please enter a reason for deleting this order (optional):",
      ""
    );
    if (reason === null) return;
    if (!window.confirm("Are you sure you want to delete this order?")) return;

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/orders/${orderId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reason: reason.trim() || "No reason provided" }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to delete order");
      }

      setOrders((prev) => prev.filter((o) => o.id !== orderId));
      addToast("Order moved to trash successfully!", "success");
    } catch (e) {
      console.error("Delete error:", e);
      addToast(e.message || "Failed to delete order", "error");
    } finally {
      setLoading(false);
    }
  };

  // ---------- UI Handlers ----------
  const handleAddOrderClick = () => {
    setEditingOrder(null);
    setPreSelectedPanchayat(null);
    setMode("form");
  };

  // ✅ FIXED: handleEditOrder - properly map prices
  const handleEditOrder = async (order) => {
    setLoading(true);
    try {
      const fullOrder = await fetchOrderDetails(order.id);
      console.log("Full order for editing:", fullOrder); // Debug log

      if (fullOrder) {
        let shippingAddress = fullOrder.shippingAddress;
        if (typeof shippingAddress === "string") {
          try {
            shippingAddress = JSON.parse(shippingAddress);
          } catch {
            shippingAddress = {};
          }
        }

        // ✅ FIXED: Map items with correct price priority
        const mappedItems = fullOrder.items.map((item) => {
          // unitPrice = the price saved in the order (could be negotiated)
          // basePrice = the product's original price from catalog
          const orderPrice = Number(item.unitPrice || item.unit_price || item.basePrice || 0);
          const originalPrice = Number(item.basePrice || item.base_price || item.unitPrice || 0);
          
          console.log(`Edit mapping item ${item.sku}:`, {
            unitPrice: item.unitPrice,
            basePrice: item.basePrice,
            orderPrice,
            originalPrice
          });

          return {
            id: item.productId || item.sku,
            product_id: item.productId,
            sku: item.sku,
            name: item.productName,
            product_name: item.productName,
            price: orderPrice,
            unit_price: orderPrice,
            originalPrice: originalPrice,
            original_price: originalPrice,
            qty: Number(item.quantity),
            quantity: Number(item.quantity),
            image: item.imageUrl,
            image_url: item.imageUrl,
          };
        });

        const editOrder = {
          id: fullOrder.orderId,
          orderNumber: `ORD-${fullOrder.orderId.substring(0, 8).toUpperCase()}`,
          customer: {
            id: fullOrder.customerId,
            name: fullOrder.customerName,
            email: fullOrder.customerEmail,
            phone: fullOrder.customerPhone,
          },
          panchayat: {
            id: fullOrder.panchayathId,
            name: fullOrder.customerName || shippingAddress?.panchayat,
            taluk: shippingAddress?.taluk || "",
            district: shippingAddress?.district || "",
            state: shippingAddress?.state || "Karnataka",
          },
          items: mappedItems,
          status: fullOrder.orderStatus,
          total: fullOrder.totalAmount,
          shippingAddress: shippingAddress,
        };

        console.log("Prepared order for form:", editOrder);

        setEditingOrder(editOrder);
        setPreSelectedPanchayat(null);
        setMode("form");
      } else {
        addToast("Failed to load order details", "error");
      }
    } catch (err) {
      console.error("Error loading order for edit:", err);
      addToast("Failed to load order details", "error");
    } finally {
      setLoading(false);
    }
  };

  // ✅ FIXED: handleViewOrder - use unitPrice instead of basePrice
  const handleViewOrder = async (order) => {
    setLoading(true);
    const fullOrder = await fetchOrderDetails(order.id);
    setLoading(false);

    if (fullOrder) {
      console.log("Full order for viewing:", fullOrder); // Debug log

      const formatAddress = (addr) => {
        if (!addr) return "-";
        if (typeof addr === "string") {
          try {
            addr = JSON.parse(addr);
          } catch {
            return addr;
          }
        }
        const parts = [
          addr.street,
          addr.landmark,
          addr.panchayat,
          addr.taluk,
          addr.district,
          addr.state,
          addr.pincode,
        ].filter(Boolean);
        return parts.length > 0 ? parts.join(", ") : "-";
      };

      setViewingOrder({
        id: fullOrder.orderId,
        orderNumber: `ORD-${fullOrder.orderId.substring(0, 8).toUpperCase()}`,

        customer: {
          name: fullOrder.customerName,
          email: fullOrder.customerEmail,
          phone: fullOrder.customerPhone,
          address: formatAddress(fullOrder.shippingAddress),
        },
        customerName: fullOrder.customerName,
        customerEmail: fullOrder.customerEmail,
        customerPhone: fullOrder.customerPhone,
        panchayathPincode: fullOrder.panchayathPincode,

        // ✅ FIXED: Use unitPrice (order's price) for display, not basePrice
        items: fullOrder.items.map((i) => ({
          sku: i.sku,
          name: i.productName,
          // ✅ Use unitPrice first (the actual price charged), fallback to basePrice
          price: Number(i.unitPrice || i.unit_price || i.basePrice || 0),
          originalPrice: Number(i.basePrice || i.base_price || 0),
          qty: i.quantity,
          subtotal: i.subtotal || (Number(i.unitPrice || i.basePrice || 0) * i.quantity),
          image: i.imageUrl,
          imageUrl: i.imageUrl,
          image_url: i.imageUrl,
          taxClass: i.taxClass,
          gstRate: i.gstRate,
          gstAmount: i.gstAmount,
          vatPercentage: i.vatPercentage,
          vatAmount: i.vatAmount,
        })),

        status: fullOrder.orderStatus,
        paymentStatus: fullOrder.paymentStatus || fullOrder.payment_status || "UNPAID",
        dateLabel: formatDateLabel(fullOrder.createdAt),

        subtotal: fullOrder.subtotal,
        gstAmount: fullOrder.gstAmount,
        gstPercentage: fullOrder.gstPercentage,
        vatAmount: fullOrder.vatAmount,
        vatPercentage: fullOrder.vatPercentage,
        taxAmount: fullOrder.taxAmount || 0,
        total: fullOrder.totalAmount,
        totalAmount: fullOrder.totalAmount,
        grandTotal: fullOrder.totalAmount,
        shippingRate: fullOrder.shippingRate || 0,
        shippingAddress: fullOrder.shippingAddress,
        shippingAddressFormatted: fullOrder.shippingAddressFormatted,

        statusHistory:
          fullOrder.statusHistory || fullOrder.status_history || {},
      });

      setMode("view");
    }
  };

  const handleCancelForm = () => {
    setEditingOrder(null);
    setPreSelectedPanchayat(null);
    setMode("table");
  };

  const handleCloseDetails = () => {
    setViewingOrder(null);
    setMode("table");
    fetchOrders();
  };

  const handleSaveOrder = async (draft) => {
    console.log("Saving order draft:", draft); // Debug log
    
    const result = draft.id
      ? await updateOrder(draft.id, draft)
      : await createOrder(draft);

    if (result.success) {
      setCurrentPage(1);
      setEditingOrder(null);
      setPreSelectedPanchayat(null);
      setMode("table");
    }
  };

  const handleClearFilters = () => {
    setFilters(defaultLocationFilters);
    setTaluks([]);
    setPanchayats([]);
  };

  // ---------- View Mode ----------
  if (mode === "view" && viewingOrder) {
    return (
      <>
        <div className="toast-container">
          {toasts.map((t) => (
            <Toast
              key={t.id}
              message={t.message}
              type={t.type}
              onClose={() => removeToast(t.id)}
            />
          ))}
        </div>
        <OrderDetails
          order={viewingOrder}
          onBack={handleCloseDetails}
          onStatusChange={updateOrderStatus}
          onPaymentStatusChange={updatePaymentStatus}
        />
      </>
    );
  }

  // ---------- Form Mode ----------
  if (mode === "form") {
    return (
      <>
        <div className="toast-container">
          {toasts.map((t) => (
            <Toast
              key={t.id}
              message={t.message}
              type={t.type}
              onClose={() => removeToast(t.id)}
            />
          ))}
        </div>
        <OrderForm
          initialOrder={editingOrder}
          preSelectedPanchayat={preSelectedPanchayat}
          onCancel={handleCancelForm}
          onSave={handleSaveOrder}
          loading={loading}
          error={error}
        />
      </>
    );
  }

  // ---------- Table Mode ----------
  return (
    <div className="orders-page">
      <div className="toast-container">
        {toasts.map((t) => (
          <Toast
            key={t.id}
            message={t.message}
            type={t.type}
            onClose={() => removeToast(t.id)}
          />
        ))}
      </div>

      {error && (
        <div className="error-toast">
          {error}
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}

      <div className="orders-header">
        <div className="orders-header-top">
          <div className="orders-header-left">
            <h1 className="orders-title">Order</h1>
            <div className="orders-breadcrumbs">
              <span className="breadcrumb-link">Dashboard</span>
              <FiChevronRight className="breadcrumb-separator-icon" />
              <span className="breadcrumb-current">Order List</span>
            </div>
          </div>

          <div className="orders-header-right">
            <button
              className="btn btn-icon-only"
              onClick={fetchOrders}
              title="Refresh"
              disabled={loading}
            >
              <FiRefreshCw className={loading ? "spinning" : ""} />
            </button>

            <button
              className="btn btn-outline btn-trash"
              onClick={() => (window.location.href = "/orders/deleted")}
              title="View Deleted Orders"
            >
              <FiTrash2 className="btn-icon" />
              <span>Trash</span>
            </button>

            <button className="btn btn-outline">
              <BiExport className="btn-icon" />
              <span>Export</span>
            </button>

            <button className="btn btn-primary" onClick={handleAddOrderClick}>
              <FiPlus className="btn-icon" />
              <span>Add Order</span>
            </button>
          </div>
        </div>

        <div className="orders-header-bottom">
          <div className="orders-tabs">
            {RANGE_TABS.map((tab) => (
              <button
                key={tab.key}
                className={`orders-tab ${activeRange === tab.key ? "active" : ""}`}
                onClick={() => setActiveRange(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="orders-header-bottom-right" ref={filterAreaRef}>
            <button
              type="button"
              className={`btn btn-outline header-filter-btn ${isDateFilterActive ? "active" : ""}`}
              onClick={() => setShowDatePopover((v) => !v)}
              title="Select dates"
            >
              <FiCalendar className="btn-icon" />
              <span>Select Dates</span>
            </button>

            <button
              type="button"
              className={`filters-btn ${showFilters ? "active" : ""} ${hasActiveFilters ? "has-filters" : ""}`}
              onClick={() => setShowFilters((prev) => !prev)}
              title="Filters"
            >
              <FiFilter className="filters-icon" />
              <span>Filters</span>
              {activeFilterCount > 0 && (
                <span className="filter-count-badge">{activeFilterCount}</span>
              )}
            </button>

            {showDatePopover && (
              <div className="orders-popover">
                <div className="orders-popover-grid">
                  <div>
                    <label>Start date</label>
                    <input
                      type="date"
                      value={dateDraft.start}
                      onChange={(e) =>
                        setDateDraft((p) => ({ ...p, start: e.target.value }))
                      }
                    />
                  </div>

                  <div>
                    <label>End date</label>
                    <input
                      type="date"
                      value={dateDraft.end}
                      onChange={(e) =>
                        setDateDraft((p) => ({ ...p, end: e.target.value }))
                      }
                    />
                  </div>
                </div>

                <div className="orders-popover-actions">
                  <button
                    className="btn btn-outline"
                    type="button"
                    onClick={clearDateFilter}
                  >
                    Clear
                  </button>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={applyDateFilter}
                  >
                    Apply
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {showFilters && (
          <div className="orders-filter-panel">
            <div className="filter-panel-content">
              <div className="filter-group">
                <label className="filter-label">District</label>
                <MultiSelectDropdown
                  options={districts.map((d) => ({ value: d.name, label: d.name }))}
                  selectedValues={filters.districts}
                  onChange={(values) =>
                    setFilters((p) => ({ ...p, districts: values }))
                  }
                  placeholder="All Districts"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Taluk</label>
                <MultiSelectDropdown
                  options={taluks.map((t) => ({ value: t.name, label: t.name }))}
                  selectedValues={filters.taluks}
                  onChange={(values) =>
                    setFilters((p) => ({ ...p, taluks: values }))
                  }
                  disabled={filters.districts.length === 0}
                  placeholder="All Taluks"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Panchayat</label>
                <MultiSelectDropdown
                  options={panchayatOptions.map((name) => ({ value: name, label: name }))}
                  selectedValues={filters.panchayats}
                  onChange={(values) =>
                    setFilters((p) => ({ ...p, panchayats: values }))
                  }
                  disabled={filters.districts.length === 0}
                  placeholder="All Panchayats"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Order Status</label>
                <select
                  className="orders-filter-select"
                  value={filters.orderStatus}
                  onChange={(e) =>
                    setFilters((p) => ({ ...p, orderStatus: e.target.value }))
                  }
                >
                  {ORDER_STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>
                      {s === "all" ? "All" : s}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label className="filter-label">Payment Status</label>
                <select
                  className="orders-filter-select"
                  value={filters.paymentStatus}
                  onChange={(e) =>
                    setFilters((p) => ({ ...p, paymentStatus: e.target.value }))
                  }
                >
                  {PAYMENT_STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>
                      {s === "all" ? "All" : s}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-actions">
                <button
                  type="button"
                  className="filter-clear-btn"
                  onClick={handleClearFilters}
                  disabled={!hasActiveFilters}
                >
                  Clear All
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="orders-card-list">
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}

        <div className="orders-table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th className="col-order-id">
                  <div className="order-header-cell">
                    <input type="checkbox" />
                    <span>Order ID</span>
                  </div>
                </th>
                <th className="col-product">
                  <span>Product</span>
                </th>
                <th className="col-date">
                  <span>Date</span>
                </th>
                 <th className="col-date">
                  <span>Taluk</span>
                </th>
                <th className="col-customer">
                  <span>Customer</span>
                </th>
                <th className="col-total">
                  <span>Total</span>
                </th>
                <th className="col-status">
                  <span>Status</span>
                </th>
                <th className="col-action">
                  <span>Action</span>
                </th>
              </tr>
            </thead>

            <tbody>
              {!loading && totalItems === 0 ? (
                <tr>
                  <td colSpan={8} className="empty-table-cell">
                    No orders yet.
                  </td>
                </tr>
              ) : (
                currentItems.map((order, index) => {
                  const additionalItems =
                    order.itemsCount > 1 ? order.itemsCount - 1 : 0;

                  return (
                    <tr key={order.id || `ord-${index}`}>
                      <td className="col-order-id" data-label="Order ID">
                        <div className="order-id-cell">
                          <input type="checkbox" className="row-checkbox" />
                          <button
                            className="order-id-link"
                            onClick={() => handleViewOrder(order)}
                          >
                            {order.orderNumber}
                          </button>
                        </div>
                      </td>

                      <td className="col-product">
                        <div className="product-preview-cell">
                          <div className="product-thumbnail">
                            {order.firstItemImage ? (
                              <img
                                src={order.firstItemImage}
                                alt={order.firstItemName || "Product"}
                                className="product-thumb-img"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div
                              className="product-thumb-placeholder"
                              style={{
                                display: order.firstItemImage ? "none" : "flex",
                              }}
                            >
                              <FiPackage />
                            </div>
                          </div>

                          <div className="product-preview-info">
                            <div className="product-preview-name">
                              {order.firstItemName || "No Product"}
                            </div>
                            {additionalItems > 0 && (
                              <div className="product-preview-more">
                                +{additionalItems} more item
                                {additionalItems > 1 ? "s" : ""}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>

                      <td className="col-date" data-label="Date">
                        {order.dateLabel}
                      </td>
                      <td className="col-taluk" data-label="Taluk">
                        <span className="taluk-text" title={order.taluk || "-"}>
                          {order.taluk || "-"}
                        </span>
                      </td>
                      <td className="col-customer" data-label="Customer">
                        <div className="customer-line">
                          <span className="customer-name">
                            {order.customer.name}
                          </span>
                          <span
                            className="customer-email"
                            title={order.customer.email}
                          >
                            {truncateEmail(order.customer.email, 10)}
                          </span>
                        </div>
                      </td>

                      <td className="col-total" data-label="Total">
                        {formatINR(order.total)}
                      </td>

                      <td className="col-status">
                        <span
                          className={`status-pill ${getStatusClass(order.status)}`}
                        >
                          {order.status}
                        </span>
                      </td>

                      <td className="col-action">
                        <div className="action-buttons2">
                          <button
                            className="icon-button small"
                            onClick={() => handleViewOrder(order)}
                            title="View Order"
                          >
                            <FiEye />
                          </button>
                          <button
                            className="icon-button small"
                            onClick={() => handleEditOrder(order)}
                            title="Edit Order"
                          >
                            <FiEdit2 />
                          </button>
                          <button
                            className="icon-button small danger"
                            onClick={() => deleteOrder(order.id)}
                            title="Delete Order"
                            disabled={loading}
                          >
                            <FiTrash2 />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {totalItems > 0 && (
          <div className="orders-pagination">
            <div className="pagination-info">
              Showing {startIndex + 1}-
              {Math.min(startIndex + PAGE_SIZE, totalItems)} of {totalItems}
            </div>
            <div className="pagination-controls">
              <button
                className="page-button"
                onClick={() => changePage(safePage - 1)}
                disabled={safePage === 1}
              >
                ‹
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={`pg-${i}`}
                  className={`page-button ${i + 1 === safePage ? "active" : ""}`}
                  onClick={() => changePage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button
                className="page-button"
                onClick={() => changePage(safePage + 1)}
                disabled={safePage === totalPages}
              >
                ›
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersList;